import {
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Switch,
} from 'antd';
import { find, sortBy } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';
import BrandApi from '../../functions/api/vehicle/BrandApi';
import { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import MyUtil from '../../functions/MyUtil';
import PricesAndQuantities from './PricesAndQuantities';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

class FormAddMotorbike extends Component {
  constructor(props) {
    super(props);

    const { vhc_part_id } = this.props.match.params;
    this.state = {
      vhc_part_id: vhc_part_id,
      types: [],
      brands: [],
      models: [],
      partners: [],
      versions: [],
      vhc_display: true,
      vhc_name: '',
      vhc_part_name: '',
      part_id: null,
      part_name: '',
      vhc_bran_name: '',
      vhc_bran_id: null,
      vhc_modl_name: '',
      isEdit: !!props.match.params.vhc_part_id,
      vehicle: [],
      isModelActive: false,
      isVersionActive: false,
    };
  }

  componentDidMount = async () => {
    const { vhc_part_id } = this.state;

    const brands = await BrandApi.getBrandByType(VEHICLE_TYPES.MOTOBIKE);
    const partners = await PartnerApi.getPartnerByOptions({
      vhc_type_id: VEHICLE_TYPES.MOTOBIKE,
    });

    const listVehicle = await VehicleApi.getVehicles();

    this.listMotobike = listVehicle.filter(
      (vhc) => vhc.vhc_type_id === VEHICLE_TYPES.MOTOBIKE
    );

    const vehicle = await VehiclePartnerApi.getDetailVehicle(vhc_part_id);

    this.setState({
      brands,
      partners,
      vehicle,
      versions: this.listMotobike.slice(),
    });
  };

  onChangeSelectPartner = (partnerId) => {
    if (partnerId) {
      const { partners } = this.state;
      const part_id = partnerId;
      const partner = part_id ? find(partners, { part_id }) : [];
      const part_name = partner.part_name;

      this.setState({ part_id: partnerId, part_name });
    }
  };

  onChangeSelectBrand = async (brandId) => {
    if (!brandId) {
      return;
    }

    const { brands, isVersionActive } = this.state;
    const vhc_bran_id = brandId;

    const brand = vhc_bran_id ? find(brands, { vhc_bran_id }) : [];
    const vhc_bran_name = brand.vhc_bran_name;

    this.setState({
      versions: this.listMotobike.filter(
        (vhc) => vhc.vhc_bran_id === vhc_bran_id
      ),
      vhc_bran_id,
      vhc_bran_name,
      isVersionActive: !isVersionActive,
    });
  };

  onChangeVersion = async (event) => {
    if (event) {
      const vhc_id = event;
      const { versions } = this.state;
      const version = vhc_id ? find(versions, { vhc_id: vhc_id }) : [];
      const vhc_name = version.vhc_name;

      this.setState({ vhc_name: vhc_name });
    }
  };

  handleChange = (event) => {
    this.setState({ vhc_part_qaty_aval: event.target.value });

    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeHide = (checked) => {
    this.setState({
      vhc_display: checked,
    });
  };

  submitForm = async (values) => {
    const { vhc_display } = this.state;
    const payload = {
      ...values,
      vhc_display,
    };
    await this.handleCreate(payload);
  };

  handleCreate = async (payload) => {
    var {
      isEdit,
      vehicle,
      vhc_name,
      vhc_part_name,
      part_name,
      vhc_modl_name,
      vhc_part_id,
      vhc_bran_name,
    } = this.state;

    const vhcPart = {
      vhc_name: vehicle.vhc_name || vhc_name,
      vhc_part_name: vehicle.vhc_part_name || vhc_part_name,
      part_id: +payload.part_id,
      part_name: vehicle.part_name || part_name,
      vhc_bran_name: vehicle.vhc_bran_name || vhc_bran_name,
      vhc_modl_name: vehicle.vhc_modl_name || vhc_modl_name,

      vhc_part_year: +payload.vhc_part_year,

      vhc_part_defa_prie: +MyUtil.convertMoney(payload.vhc_part_defa_prie),
      vhc_partner_price_week: +MyUtil.convertMoney(
        payload.vhc_partner_price_week
      ),
      vhc_partner_price_month: +MyUtil.convertMoney(
        payload.vhc_partner_price_month
      ),
      vhc_partner_price_quarter: +MyUtil.convertMoney(
        payload.vhc_partner_price_quarter
      ),
      vhc_partner_price_year: +MyUtil.convertMoney(
        payload.vhc_partner_price_year
      ),
      vhc_partner_price_2hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_2hours
      ),
      vhc_partner_price_4hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_4hours
      ),
      vhc_partner_price_8hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_8hours
      ),
      vhc_partner_price_12hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_12hours
      ),
      vhc_partner_price_24hours: +MyUtil.convertMoney(
        payload.vhc_partner_price_24hours
      ),
      vhc_partner_price_2week: +MyUtil.convertMoney(
        payload.vhc_partner_price_2week
      ),
      vhc_partner_price_halfyear: +MyUtil.convertMoney(
        payload.vhc_partner_price_halfyear
      ),

      vhc_part_qaty_tota: +payload.vhc_part_qaty_tota,
      vhc_part_qaty_aval: +payload.vhc_part_qaty_aval,
      vhc_part_hide: payload.vhc_display ? 0 : 1,

      vhc_part_id: vehicle.vhc_part_id || vhc_part_id,
      vhc_part_depo: vehicle.vhc_part_depo,
      vhc_part_polc: vehicle.vhc_part_polc,
      vhc_part_prty: vehicle.vhc_part_prty,
      vhc_part_crta: vehicle.vhc_part_crta,

      vhc_part_del: vehicle.vhc_part_del,
    };

    let result = [];

    if (isEdit) {
      vhcPart.vhc_part_upda = new Date();
      result = await VehiclePartnerApi.editVehiclePartner(vhcPart);
      if (!result['message']) {
        message.success('Sửa xe đối tác thành công tác thành công');
        this.props.history.push('/vehicle-partner');
        this.clearForm();
      } else {
        message.error('Lỗi');
      }
    } else {
      vhcPart.vhc_part_crta = new Date();
      result = await VehiclePartnerApi.createVehiclePartner(vhcPart);
      if (!result['message']) {
        message.success('Thêm xe đối tác thành công');
        this.props.history.push('/vehicle-partner');
        this.clearForm();
      } else {
        message.error('Lỗi');
      }
    }
  };

  render() {
    const {
      brands,
      versions,
      partners,
      vhc_display,
      vehicle,
      isEdit,
      isVersionActive,
    } = this.state;

    if (!vehicle.vhc_part_id && isEdit) {
      return <Spin />;
    }

    return (
      <div>
        <h3>
          {vehicle.vhc_part_id
            ? `Sửa xe của đối tác ${vehicle.part_name}`
            : 'Thêm xe xe máy đối tác'}
        </h3>

        <Form
          {...formItemLayout}
          initialValues={vehicle}
          onFinish={this.submitForm}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['part_id']}
                label="Tên đối tác"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(partners, ['part_name']).map((p) => ({
                    value: p.part_id,
                    label: p.part_name,
                  }))}
                  onChange={this.onChangeSelectPartner}
                  disabled={!!vehicle.vhc_part_id}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_bran_id']}
                label="Hãng xe"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(brands, ['vhc_bran_name']).map((b) => ({
                    value: b.vhc_bran_id,
                    label: b.vhc_bran_name,
                  }))}
                  onChange={this.onChangeSelectBrand}
                  disabled={!!vehicle.vhc_part_id}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_id']}
                label="Version"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(versions, ['vhc_name']).map((v) => ({
                    value: v.vhc_id,
                    label: v.vhc_name,
                  }))}
                  onChange={this.onChangeVersion}
                  disabled={!!vehicle.vhc_part_id || !isVersionActive}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_part_year']}
                label="Năm sản xuất"
                rules={[{ required: true }]}
              >
                <Input onChange={this.handleChange} />
              </Form.Item>
            </Col>

            <PricesAndQuantities onChange={this.handleChange} />
          </Row>
          <Form.Item label="Ẩn hiện xe">
            <Switch
              onChange={this.handleChangeHide}
              checked={vhc_display}
              id="normal-switch"
            />
          </Form.Item>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Button onClick={() => this.props.history.push('/vehicle-partner')}>
              Quay lại
            </Button>
          </Space>
        </Form>
      </div>
    );
  }
}

export default withRouter(FormAddMotorbike);
